
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33883',
  depVersions: {
  "documents-public-ui": "static-1.33883",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33888",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1891",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5357",
  "hs-test-utils": "static-1.7772",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1561",
  "jasmine-immutable": "static-1.2785",
  "jasmine-runner": "static-1.6240",
  "lodash": "static-1.3",
  "quartz": "static-1.6682",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16406",
  "reporting-data": "static-1.66371",
  "reporting-testing-lib": "static-1.8304",
  "reporting-visualizations": "static-1.58447",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4532",
  "webpack-env": "static-1.54",
  "atom": "static-1.4837",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2251",
  "classnames": "static-2.10",
  "cssUtils": "static-1.722",
  "customer-data-filters-ui": "static-1.38758",
  "customer-data-objects": "static-1.7410",
  "customer-data-property-utils": "static-1.7837",
  "data-fetching-client": "static-1.9443",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4297",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85203",
  "FormUrlGenerator": "static-2.4496",
  "foundations-components": "static-1.7457",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11495",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6928",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3625",
  "property-translator": "static-1.5179",
  "quartz-config": "static-1.460",
  "quartz-core": "static-1.5901",
  "quick-fetch": "static-1.3703",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5144",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7926",
  "reference-resolvers-lite": "static-1.7856",
  "report-customization-components": "static-1.12395",
  "reporting-enablement": "static-1.21952",
  "reporting-reports": "static-1.66049",
  "reporting-snowflake": "static-1.54989",
  "reporting-ui-components": "static-2.63643",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4398",
  "sales-content-partitioning": "static-1.8701",
  "SalesContentIndexUI": "static-3.8850",
  "sanitize": "static-1.4240",
  "sanitize-text": "static-1.7906",
  "self-service-api": "static-1.10002",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1520",
  "signup-constants": "static-1.18319",
  "signup-ui-lego-core": "static-1.20329",
  "signup-ui-url-generator": "static-2.7829",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4538",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10761",
  "ui-addon-i18n": "static-1.10897",
  "ui-addon-react-router-dom": "static-1.9314",
  "ui-addon-upgrades": "static-9.17598",
  "ui-asset-management-lib": "static-1.10663",
  "ui-images": "static-2.1083",
  "UIComponents": "static-3.8134",
  "usage-tracker": "static-1.7100",
  "usage-tracker-container": "static-1.7090",
  "usage-tracker-core": "static-1.6950",
  "usage-tracker-public": "static-1.6911",
  "viral-links-lib": "static-1.6794",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2959",
  "quartz-webpack": "static-1.2906",
  "ai-components-ui-library": "static-1.8255",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4598",
  "foundations-theming": "static-1.4175",
  "quartz-auth": "static-1.357",
  "usage-tracker-session-replay": "static-1.4786",
  "foundations-theming-base": "static-1.3160",
  "HeadJS": "static-2.703",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2883",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4097",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7691",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3473",
  "reporting-client-types": "static-1.2374",
  "hs-story-utils": "static-1.9194",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9392",
  "hubspotter-http": "static-1.4447",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7016",
  "crm-message-bus": "static-1.42245",
  "customer-data-filters-ui-msw-helpers": "static-1.21192",
  "customer-data-objects-ui-components": "static-1.12769",
  "customer-data-reference-ui-components": "static-1.12908",
  "customer-data-ui-utilities": "static-1.9590",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6540",
  "framework-data-schema-resolvers": "static-1.6635",
  "inbound-db-properties-service-client": "static-1.3645",
  "multi-account-reference-resolvers": "static-1.735",
  "onboarding-tours": "static-1.16211",
  "reporting-datasets-permissions-lib": "static-1.12952",
  "ui-addon-teams": "static-1.21194",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67518",
  "customer-data-properties": "static-1.50685",
  "forms-ai-lib": "static-1.3962",
  "forms-utils-lib": "static-1.12106",
  "foundations-components-test-utils": "static-1.4940",
  "react-dnd-compat": "static-1.4390",
  "react-tinymce": "static-1.54526",
  "tinymce-config": "static-2.53652",
  "ui-gdpr-components": "static-1.10113",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3726",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1095",
  "ui-fonts": "static-1.449",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.786",
  "mobile-manifest-mixins": "static-1.475",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.347",
  "quartz-i18n": "static-1.357",
  "quartz-routing": "static-1.112",
  "quartz-test": "static-1.357",
  "batch-promise": "static-1.1316",
  "external-options-client-types": "static-1.3953",
  "react-colorpicker": "static-2.9978",
  "copilot-toolkit": "static-1.10434",
  "data-quality-ui-library": "static-1.12239",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40554",
  "reporting-insights-lib": "static-1.1059",
  "reporting-plugins": "static-1.9938",
  "ui-addon-draggable-compat": "static-2.4020",
  "ui-addon-opt": "static-4.8152",
  "ui-shepherd-react": "static-3.9910",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24625",
  "hubspot-apollo-client": "static-1.4645",
  "sales-templates-service-types-lib": "static-1.3963",
  "ui-business-units-lib": "static-1.8789",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5435",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3874",
  "upgrade-management-service-types": "static-1.4273",
  "timezone-utils": "static-2.5010",
  "bender-build-tools": "static-1.2903",
  "chatspot-core": "static-1.20172",
  "chirp-fetch": "static-1.1649",
  "bend-plugin-foundations-theming": "static-1.2658",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9390",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3593",
  "crm-pipelines-api-client-types": "static-1.3934",
  "multi-currency-client-types": "static-1.3487",
  "getting-started-shared-tasks": "static-1.17782",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2836",
  "growth-onboarding-next-action-utils": "static-1.1261",
  "navigation-components": "static-1.17152",
  "onboarding-tours-client": "static-1.4425",
  "onboarding-tours-utils": "static-1.277",
  "ui-shepherd-tracker": "static-1.7291",
  "ui-universal-auth": "static-1.8644",
  "user-context": "static-1.4860",
  "cms-field-types": "static-1.4572",
  "content-icons-ui": "static-1.2144",
  "integrations-lib": "static-1.15302",
  "calling-global-api": "static-1.63534",
  "calling-internal-common": "static-1.31058",
  "calling-lifecycle-internal": "static-1.64916",
  "calling-lifecycle-messages": "static-1.57210",
  "commerce-products-lib": "static-1.8749",
  "crm-links": "static-1.6020",
  "file-manager-components": "static-1.22785",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.437",
  "inbounddb-objects-service-types": "static-1.4019",
  "meetings-icalendar-utils-lib": "static-1.400",
  "object-builder-ui-client": "static-1.47851",
  "pipeline-validation-client-types": "static-1.3756",
  "property-value-citations": "static-1.1299",
  "pulse": "static-1.269",
  "smart-property-lib": "static-1.5751",
  "tiered-pricing": "static-1.778",
  "ui-addon-iframeable": "static-1.8807",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19415",
  "tinymce-themes": "static-1.55622",
  "data-token-picker": "static-1.15988",
  "hub-http-contrib": "static-1.2811",
  "interframe": "static-3.4558",
  "tinymce-data": "static-1.39737",
  "tinymce-plugins": "static-1.56766",
  "ui-addon-sales-email": "static-1.4979",
  "magpie-lib": "static-1.5360",
  "magpie-types": "static-1.4820",
  "simple-logging-lib": "static-1.2816",
  "content-assistance-lib": "static-1.7397",
  "dashboard-lib": "static-1.80468",
  "ExportDialog": "static-6.10154",
  "hubspot-prosemirror": "static-1.17504",
  "hubspot-prosemirror-plugins": "static-1.17496",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8456",
  "campaign-roi-lib": "static-1.8182",
  "feedback-loader": "static-1.28788",
  "onboarding-scopes": "static-1.6230",
  "apollo-link-hub-http": "static-2.4415",
  "hubspot-apollo-cache": "static-1.104",
  "growth-monetization-service-types": "static-1.4289",
  "nav-client-types": "static-1.2121",
  "purchase-motions-api": "static-1.5438",
  "trials-service-types": "static-1.3690",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.492",
  "getting-started-shared-tasks-store": "static-1.16900",
  "integrations-error-boundary-lib": "static-1.12717",
  "integrations-tracking-lib": "static-1.5349",
  "native-integrations-shared-strings": "static-1.7554",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10139",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31064",
  "shared-worker-versioning": "static-1.10804",
  "calling-usage-tracker": "static-1.6304",
  "voice-sms-access-library": "static-1.140",
  "customer-data-tracking": "static-1.6648",
  "products-iframe-lib": "static-1.7221",
  "products-ui-components-shared-msw-handlers": "static-1.9774",
  "location-customization-utils-lib": "static-1.8445",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3920",
  "video-components-external": "static-1.10472",
  "video-data-lib": "static-1.34130",
  "directed-graph": "static-1.703",
  "event-emitter": "static-1.713",
  "breeze-intelligence-kit": "static-1.5270",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9475",
  "fsm": "static-1.3497",
  "policy-lib": "static-1.6550",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9538",
  "navigation-messaging": "static-1.6479",
  "FileManagerLib": "static-1.38425",
  "NamespacedHubStyle": "static-2.8866",
  "FileManagerCore": "static-1.38284",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11971",
  "layout-dnd-utils": "static-1.10946",
  "react-codemirror": "static-1.10393",
  "ui-addon-emoji-picker": "static-1.9655",
  "ui-brand-identity-lib": "static-1.13695",
  "ui-addon-video-player": "static-1.8461",
  "ui-coaching-tips": "static-1.27851",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8334",
  "payment-link-components": "static-1.22837",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2971",
  "universal-page-editor-lib": "static-1.2763",
  "calling-orchestration-schema": "static-1.34917",
  "sales-views-client-types": "static-1.4058",
  "crm-record-cards-service-types": "static-1.3421",
  "content-media-composition-data-lib": "static-1.11327",
  "content-media-compositions": "static-2.15334",
  "media-bridge-lib": "static-1.18510",
  "trellis-story-utils": "static-1.4289",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5562",
  "FileManagerImages": "static-1.35936",
  "video-components": "static-1.12475",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4300",
  "video-embed": "static-1.34964",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67593",
  "layout-data-lib": "static-1.9271",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6352",
  "commerce-tours-lib": "static-1.5666",
  "growth-onboarding-reliability": "static-1.4855",
  "sales-checkout-service-client": "static-1.3443",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21253",
  "sales-email-signature-service-client": "static-1.3610",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21256",
  "outpost": "static-1.3974",
  "advanced-menus-core": "static-1.14766",
  "advanced-menus-lib": "static-1.11748",
  "ui-memberships-settings-lib": "static-1.33334",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14765",
  "simple-menus-lib": "static-1.16282"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33883",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33888",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1891",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5357",
  "hs-test-utils": "/hs-test-utils/static-1.7772",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1561",
  "jasmine-immutable": "/jasmine-immutable/static-1.2785",
  "jasmine-runner": "/jasmine-runner/static-1.6240",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6682",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16406",
  "reporting-data": "/reporting-data/static-1.66371",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8304",
  "reporting-visualizations": "/reporting-visualizations/static-1.58447",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4532",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4837",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2251",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.722",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38758",
  "customer-data-objects": "/customer-data-objects/static-1.7410",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7837",
  "data-fetching-client": "/data-fetching-client/static-1.9443",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4297",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85203",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4496",
  "foundations-components": "/foundations-components/static-1.7457",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11495",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6928",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3625",
  "property-translator": "/property-translator/static-1.5179",
  "quartz-config": "/quartz-config/static-1.460",
  "quartz-core": "/quartz-core/static-1.5901",
  "quick-fetch": "/quick-fetch/static-1.3703",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5144",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7926",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7856",
  "report-customization-components": "/report-customization-components/static-1.12395",
  "reporting-enablement": "/reporting-enablement/static-1.21952",
  "reporting-reports": "/reporting-reports/static-1.66049",
  "reporting-snowflake": "/reporting-snowflake/static-1.54989",
  "reporting-ui-components": "/reporting-ui-components/static-2.63643",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4398",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8701",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8850",
  "sanitize": "/sanitize/static-1.4240",
  "sanitize-text": "/sanitize-text/static-1.7906",
  "self-service-api": "/self-service-api/static-1.10002",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1520",
  "signup-constants": "/signup-constants/static-1.18319",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20329",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7829",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4538",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10761",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10897",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9314",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17598",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10663",
  "ui-images": "/ui-images/static-2.1083",
  "UIComponents": "/UIComponents/static-3.8134",
  "usage-tracker": "/usage-tracker/static-1.7100",
  "usage-tracker-container": "/usage-tracker-container/static-1.7090",
  "usage-tracker-core": "/usage-tracker-core/static-1.6950",
  "usage-tracker-public": "/usage-tracker-public/static-1.6911",
  "viral-links-lib": "/viral-links-lib/static-1.6794",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2959",
  "quartz-webpack": "/quartz-webpack/static-1.2906",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8255",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4598",
  "foundations-theming": "/foundations-theming/static-1.4175",
  "quartz-auth": "/quartz-auth/static-1.357",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4786",
  "foundations-theming-base": "/foundations-theming-base/static-1.3160",
  "HeadJS": "/HeadJS/static-2.703",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2883",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4097",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3473",
  "reporting-client-types": "/reporting-client-types/static-1.2374",
  "hs-story-utils": "/hs-story-utils/static-1.9194",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9392",
  "hubspotter-http": "/hubspotter-http/static-1.4447",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7016",
  "crm-message-bus": "/crm-message-bus/static-1.42245",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21192",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12769",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12908",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9590",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6540",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6635",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3645",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.735",
  "onboarding-tours": "/onboarding-tours/static-1.16211",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12952",
  "ui-addon-teams": "/ui-addon-teams/static-1.21194",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67518",
  "customer-data-properties": "/customer-data-properties/static-1.50685",
  "forms-ai-lib": "/forms-ai-lib/static-1.3962",
  "forms-utils-lib": "/forms-utils-lib/static-1.12106",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4940",
  "react-dnd-compat": "/react-dnd-compat/static-1.4390",
  "react-tinymce": "/react-tinymce/static-1.54526",
  "tinymce-config": "/tinymce-config/static-2.53652",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10113",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3726",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1095",
  "ui-fonts": "/ui-fonts/static-1.449",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.475",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.347",
  "quartz-i18n": "/quartz-i18n/static-1.357",
  "quartz-routing": "/quartz-routing/static-1.112",
  "quartz-test": "/quartz-test/static-1.357",
  "batch-promise": "/batch-promise/static-1.1316",
  "external-options-client-types": "/external-options-client-types/static-1.3953",
  "react-colorpicker": "/react-colorpicker/static-2.9978",
  "copilot-toolkit": "/copilot-toolkit/static-1.10434",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12239",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40554",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1059",
  "reporting-plugins": "/reporting-plugins/static-1.9938",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4020",
  "ui-addon-opt": "/ui-addon-opt/static-4.8152",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9910",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24625",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4645",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3963",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8789",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5435",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3874",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4273",
  "timezone-utils": "/timezone-utils/static-2.5010",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "chatspot-core": "/chatspot-core/static-1.20172",
  "chirp-fetch": "/chirp-fetch/static-1.1649",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2658",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9390",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3593",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3934",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3487",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17782",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2836",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1261",
  "navigation-components": "/navigation-components/static-1.17152",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4425",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.277",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7291",
  "ui-universal-auth": "/ui-universal-auth/static-1.8644",
  "user-context": "/user-context/static-1.4860",
  "cms-field-types": "/cms-field-types/static-1.4572",
  "content-icons-ui": "/content-icons-ui/static-1.2144",
  "integrations-lib": "/integrations-lib/static-1.15302",
  "calling-global-api": "/calling-global-api/static-1.63534",
  "calling-internal-common": "/calling-internal-common/static-1.31058",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64916",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57210",
  "commerce-products-lib": "/commerce-products-lib/static-1.8749",
  "crm-links": "/crm-links/static-1.6020",
  "file-manager-components": "/file-manager-components/static-1.22785",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.437",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4019",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.400",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47851",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3756",
  "property-value-citations": "/property-value-citations/static-1.1299",
  "pulse": "/pulse/static-1.269",
  "smart-property-lib": "/smart-property-lib/static-1.5751",
  "tiered-pricing": "/tiered-pricing/static-1.778",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8807",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19415",
  "tinymce-themes": "/tinymce-themes/static-1.55622",
  "data-token-picker": "/data-token-picker/static-1.15988",
  "hub-http-contrib": "/hub-http-contrib/static-1.2811",
  "interframe": "/interframe/static-3.4558",
  "tinymce-data": "/tinymce-data/static-1.39737",
  "tinymce-plugins": "/tinymce-plugins/static-1.56766",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4979",
  "magpie-lib": "/magpie-lib/static-1.5360",
  "magpie-types": "/magpie-types/static-1.4820",
  "simple-logging-lib": "/simple-logging-lib/static-1.2816",
  "content-assistance-lib": "/content-assistance-lib/static-1.7397",
  "dashboard-lib": "/dashboard-lib/static-1.80468",
  "ExportDialog": "/ExportDialog/static-6.10154",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17504",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17496",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8456",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "feedback-loader": "/feedback-loader/static-1.28788",
  "onboarding-scopes": "/onboarding-scopes/static-1.6230",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4415",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.104",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4289",
  "nav-client-types": "/nav-client-types/static-1.2121",
  "purchase-motions-api": "/purchase-motions-api/static-1.5438",
  "trials-service-types": "/trials-service-types/static-1.3690",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.492",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16900",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12717",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5349",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7554",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10139",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31064",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10804",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6304",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.140",
  "customer-data-tracking": "/customer-data-tracking/static-1.6648",
  "products-iframe-lib": "/products-iframe-lib/static-1.7221",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9774",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8445",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3920",
  "video-components-external": "/video-components-external/static-1.10472",
  "video-data-lib": "/video-data-lib/static-1.34130",
  "directed-graph": "/directed-graph/static-1.703",
  "event-emitter": "/event-emitter/static-1.713",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5270",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9475",
  "fsm": "/fsm/static-1.3497",
  "policy-lib": "/policy-lib/static-1.6550",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9538",
  "navigation-messaging": "/navigation-messaging/static-1.6479",
  "FileManagerLib": "/FileManagerLib/static-1.38425",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8866",
  "FileManagerCore": "/FileManagerCore/static-1.38284",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11971",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10946",
  "react-codemirror": "/react-codemirror/static-1.10393",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9655",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13695",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8461",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27851",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8334",
  "payment-link-components": "/payment-link-components/static-1.22837",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2971",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34917",
  "sales-views-client-types": "/sales-views-client-types/static-1.4058",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3421",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11327",
  "content-media-compositions": "/content-media-compositions/static-2.15334",
  "media-bridge-lib": "/media-bridge-lib/static-1.18510",
  "trellis-story-utils": "/trellis-story-utils/static-1.4289",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5562",
  "FileManagerImages": "/FileManagerImages/static-1.35936",
  "video-components": "/video-components/static-1.12475",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4300",
  "video-embed": "/video-embed/static-1.34964",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67593",
  "layout-data-lib": "/layout-data-lib/static-1.9271",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6352",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5666",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4855",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3443",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21253",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3610",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21256",
  "outpost": "/outpost/static-1.3974",
  "advanced-menus-core": "/advanced-menus-core/static-1.14766",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11748",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33334",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14765",
  "simple-menus-lib": "/simple-menus-lib/static-1.16282"
}
};
